import React, { FunctionComponent } from 'react';
import CardModal from 'components/Modal/Card';
import { Body, CardBlock } from 'components/Card';
import Content from './View';
import { useContactSupport } from './useContactSupport';

const ContactSupportModal: FunctionComponent = () => {
  const { isOpen, step, goToNextStep, goToPrevStep, title, handleClose } = useContactSupport();

  if (!isOpen) return null;

  return (
    <CardModal title={title} close={handleClose}>
      <CardBlock>
        <Body>
          <Content
            step={step}
            goToNextStep={goToNextStep}
            goToPrevStep={goToPrevStep}
            onClose={handleClose}
          />
        </Body>
      </CardBlock>
    </CardModal>
  );
};

export default ContactSupportModal;
